import React from 'react'
import KYCHris from './KYCHris'
import KYCCsv from './KYCCsv'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'

interface KYCCompletionDrawerProps {
  isOpen: boolean
  onClose: () => void
}

const KYCCompletionDrawer = (props: KYCCompletionDrawerProps) => {
  const { isOpen, onClose } = props
  const { workforceSyncType } = useSelector(
    (state: AppState) => state.onboarding
  )

  if (workforceSyncType === 'CSV') {
    return <KYCCsv isOpen={isOpen} onClose={onClose} />
  }
  return <KYCHris isOpen={isOpen} onClose={onClose} />
}

// Helps identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  KYCCompletionDrawer.displayName = 'KYCCompletionDrawer'
}

export default KYCCompletionDrawer
